"use client";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useRef } from "react";
import { audioPlayer } from "~/services/audioPlayer.service";
import { mediaSession } from "~/services/mediasession.service";
import AudioPlayerBar from "./AudioPlayerBar";
import CastBridge from "./CastBridge";
import { audioStore } from "./audioStore";


function AudioElements({ children }: { children: React.ReactNode }) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    audioStore.getState().setRouter(router);
  }, [router]);

  useEffect(() => {
    audioPlayer.attach(audioRef.current);

    mediaSession.init();

    return () => audioPlayer.detach();
  }, []);

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    // This only runs on actual route changes
    sessionStorage.setItem("hasInternalHistory", "true");
  }, [pathname]);

  return (
    <>
      {children}
      <AudioPlayerBar />
      <CastBridge />
      <audio ref={audioRef} preload="auto" style={{ display: "none" }} />
    </>
  );
}

export default AudioElements;
